import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { compose, withState, withHandlers } from 'recompose';
import { trim } from 'lodash';

import { Text } from 'components/core/Text';
import { Image } from 'components/core/Image';
import { Button } from 'components/core/Button';
import { Modal, ModalBody } from 'components/core/Modal';

import './ModalLink.scss';

export const enhance = compose(
	withState('showing', 'setShowing', false),
	withHandlers({
		toggleModalLinkShowing: ({ onClick, setShowing }) => () => {
			setShowing((showing) => !showing);
			if (onClick) { onClick(); }
		}
	})
);

export function ModalLink({
	className, text, content, toggleModalLinkShowing, showing,
	reverse, size, hideIcon, button, additionalProps, family, Icon, usePortal
}) {
	const modalElement = !!content && showing && (
		<Modal
			showing={showing}
			closeable
			onClose={toggleModalLinkShowing}
		>
			<ModalBody>
				{content}
			</ModalBody>
		</Modal>
	);

	return (
		<div
			className={
				classnames(
					'modal-link',
					className,
					{
						'hide-icon': hideIcon,
						reverse
					}

				)
			}
		>
			<Button
				onClick={toggleModalLinkShowing}
				link={!button}
				{...additionalProps}
			>
				<Text className="modal-link-link" strong family={family} size={size}>
					{text}
					{' '}{Icon}
				</Text>
			</Button>
			
			{usePortal && typeof document !== 'undefined'
				? modalElement && ReactDOM.createPortal(modalElement, document.body)
				: modalElement
			}
			
		</div>
	);
}

ModalLink.propTypes = {
	className: PropTypes.string,
	text: PropTypes.node.isRequired,
	content: PropTypes.node,
	toggleModalLinkShowing: PropTypes.func,
	reverse: PropTypes.bool,
	showing: PropTypes.bool,
	size: PropTypes.string,
	hideIcon: PropTypes.bool,
	button: PropTypes.bool,
	additionalProps: PropTypes.object,
	usePortal: PropTypes.bool
};

ModalLink.defaultProps = {
	size: 'tiny',
	usePortal: false
};

export default enhance(ModalLink);
